// src/pages/system/ClientRegister.js

import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { authService } from '../../services/api';
import '../../styles/system/ClientRegister.css';

const ClientRegister = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting }
  } = useForm();

  const onSubmit = async (data) => {
    try {
      await authService.registerCliente(data);
      navigate('/login');
    } catch (err) {
      setError('root', { message: err.message || 'Erro no cadastro' });
    }
  };

  return (
    <div className="client-register-container">
      <div className="client-register-box">
        <h2>Cadastro na Liv_IAm</h2>

        {errors.root && <div className="client-register-error">{errors.root.message}</div>}

        <form onSubmit={handleSubmit(onSubmit)} className="client-register-form">
          <input {...register('nome', { required: 'Nome completo é obrigatório' })} placeholder="Nome completo" />
          {errors.nome && <small>{errors.nome.message}</small>}

          <input {...register('apelido', { required: 'Apelido é obrigatório' })} placeholder="Apelido" />
          {errors.apelido && <small>{errors.apelido.message}</small>}

          <input type="email" {...register('email', { required: 'Email é obrigatório' })} placeholder="E-mail" />
          {errors.email && <small>{errors.email.message}</small>}

          <input type="password" {...register('password', { required: 'Senha é obrigatória' })} placeholder="Senha" />
          {errors.password && <small>{errors.password.message}</small>}

          <InputMask mask="999.999.999-99" {...register('cpf', { required: 'CPF obrigatório' })} placeholder="CPF" />
          {errors.cpf && <small>{errors.cpf.message}</small>}

          <InputMask mask="99.999.999-9" {...register('rg', { required: 'RG obrigatório' })} placeholder="RG" />
          {errors.rg && <small>{errors.rg.message}</small>}

          <InputMask mask="99/99/9999" {...register('data_nascimento', { required: 'Data obrigatória' })} placeholder="Data de nascimento" />
          {errors.data_nascimento && <small>{errors.data_nascimento.message}</small>}

          <InputMask mask="99:99" {...register('hora_nascimento', { required: 'Hora obrigatória' })} placeholder="Hora de nascimento" />
          {errors.hora_nascimento && <small>{errors.hora_nascimento.message}</small>}

          <input {...register('cidade_nascimento', { required: 'Cidade obrigatória' })} placeholder="Cidade de nascimento" />
          {errors.cidade_nascimento && <small>{errors.cidade_nascimento.message}</small>}

          <button type="submit" disabled={isSubmitting} className="client-register-button">
            {isSubmitting ? 'Cadastrando...' : 'Cadastrar'}
          </button>
        </form>

        <p className="client-register-login-link">
          Já tem conta? <Link to="/client/login">Faça login</Link>
        </p>
      </div>
    </div>
  );
};

export default ClientRegister;